module.exports = __webpack_public_path__ + "static/media/esmaabi.806de714.svg";